<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    padding: utils.in_rem(16px);
    gap: utils.in_rem(16px);
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
</style>

<script>
  import LicenseRow from "./Components/LicenseRow.svelte";
  import WarningHeader from "./Components/WarningHeader.svelte";
  import { licenseAvailabilityInfo, modulesStore } from "./stores";

  let { style } = $props();
</script>

<div class="container" {style}>
  <WarningHeader />
  {#each $modulesStore as mod}
    {@const licenseInfo = $licenseAvailabilityInfo[mod.kind] || {
      available: false,
      remaining: 0,
    }}
    <LicenseRow {mod} {licenseInfo} />
  {/each}
</div>
